export default __webpack_public_path__ + "static/media/fetch_pals_post3.193ce598.jpg";